module.exports = __webpack_public_path__ + "brandon_thin_it-webfont.2464d8afb806d84c14bd.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_thin_it-webfont.woff2
// module id = 954
// module chunks = 7